import { isJSON } from './string';

export class LocalStorage {
  static get<T = any>(key: string): T | null {
    const value = localStorage.getItem(key);

    if (!value) return null;

    return isJSON(value) ? JSON.parse(value) : value;
  }

  static set<T = string>(key: string, value: T): void {
    localStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
  }
}
